import React, { Fragment } from 'react';
import './StepsProgress.css';
import clsx from 'clsx';

export interface StepsProgrssProps {
  steps: number;
  currentStep: number;
}

const StepsProgress: React.FC<StepsProgrssProps> = ({
  steps,
  currentStep,
}: StepsProgrssProps) => (
  <div className="stepsProgress">
    {[...Array(steps)].map((x, i) => {
      const step = i + 1;
      return (
        <Fragment key={i}>
          <div
            key={i}
            className={clsx('circle', step <= currentStep && 'active')}
          ></div>
          {step < steps && (
            <div className={clsx('line', step < currentStep && 'active')}></div>
          )}
        </Fragment>
      );
    })}
  </div>
);

export default StepsProgress;
